import React from "react";
import "./style/main.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Homepage } from "./pages/Homepage";
import { HomepageZerto } from "./pages/HomepageZerto";
import LeadsPage from "./pages/LeadsPage";
import ZertoLeadsPage from "./pages/ZertoLeadsPage";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import Disclaimer from "./pages/Disclaimer";
import NotFound from "./pages/NotFound";
// import Forbidden from "./pages/Forbidden";
import { ThankYou } from "./pages/ThankYou";
import { ThankYouZerto } from "./pages/ThankYouZerto";
import EnterpriseOne from "./pages/EnterpriseOne";
import ThankyouEnterpriseOne from "./pages/ThankyouEnterpriseOne";
import EnterpriseTwo from "./pages/EnterpriseTwo";
import EnterpriseThree from "./pages/ZertoOne";
import FormZerto from "./components/sections/formpage/FormZerto";
import ZertoOne from "./pages/ZertoOne";
import ZertoThankyouOne from "./pages/ZertoThankyouOne";
import ZertoTwo from "./pages/ZertoTwo";
import GTMProvider from "./components/GTMProvider";
import { OldZerto } from "./pages/OldZerto";
// import ProductList from "./pages/ProductList";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  return token ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/auth" state={{ from: location }} />
  );
};

const App = () => {
  return (
    <Router>
      <GTMProvider />
      <Routes>
        <Route path="/" element={<Homepage />} />

        <Route path="/zerto" element={<HomepageZerto />} />
        <Route path="/zerto/thank-you" element={<ZertoThankyouOne />} />

        <Route path="/hpe-zerto-software" element={<OldZerto />} />
        <Route
          path="/hpe-zerto-software/thank-you"
          element={<ThankYouZerto />}
        />

        {/* <Route path="/hpe" element={<Homepage />} /> */}
        {/* <Route path="/form" element={<Formpage />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndCondition />} />
        <Route path="/disclaimer" element={<Disclaimer />} />

        <Route path="/auth" element={<Login />} />
        {/* <Route path="/user-create" element={<SignUp />} /> */}
        {/* <Route path="/discounted-product" element={<ProductList />} /> */}
        <Route path="/leads" element={<PrivateRoute component={LeadsPage} />} />
        <Route
          path="/zerto/leads"
          element={<PrivateRoute component={ZertoLeadsPage} />}
        />
        <Route path="/thank-you" element={<ThankyouEnterpriseOne />} />
        {/* <Route path="/enterprise-1" element={<EnterpriseOne />} /> */}
        {/* <Route path="/enterprise-2" element={<EnterpriseTwo />} /> */}
        {/* <Route path="/zerto-1" element={<ZertoOne />} /> */}
        {/* <Route path="/zerto-2" element={<ZertoTwo />} /> */}
        {/* <Route path="/enterprise-3" element={<FormZerto />} /> */}
        {/* <Route
          path="/enterprise-1/thank-you"
          element={<ThankyouEnterpriseOne />}
        /> */}
        {/* <Route
          path="/enterprise-2/thank-you"
          element={<ThankyouEnterpriseOne />}
        /> */}
        {/* <Route path="/zerto-1/thank-you" element={<ZertoThankyouOne />} />
        <Route path="/zerto-2/thank-you" element={<ZertoThankyouOne />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
